import React from "react";
import styled from "@emotion/styled";
import {breakpoints, color} from "../../utils/style";
import IcomoonIcon from '../shared/IcomoonIcon';

export const showHideChat = (id, frameID) => {
  const chatBox = document.getElementById(id);
  let chatIframe = document.getElementById(frameID);

  chatBox.classList.toggle('open');

  if (chatBox.classList.contains('open') && (!chatIframe.src || chatIframe.src === 'about:blank')) {
    chatIframe.src = process.env.FRESHCHAT_LOCAL;
  }
  else {
    document.body.style.overflow = 'initial';
  }
};

const Wrap = styled('div')`
  .live-chat {
    bottom: 10px;
    position: fixed;
    right: 10px;
    z-index: 1;
    background: ${color.orange};
    padding: 5px 30px;
    font-size: 1rem;
    font-weight: bold;
    line-height: 35px;
    color: #000;
    cursor: pointer;
    outline:none;
    border:none;
    border-radius: 25px;
    text-transform: uppercase;
    svg {
      margin-right: 10px;
    }
  }
  
  .live-chat-text {
    padding: 5px 10px;
    background: ${color.white};
    margin-top:-12px;
    line-height: 2;
    font-size: 14px;
    font-style: italic;
  }
    
  .live-chat-popup {
    height: 590px;
    width: 430px;
    position:fixed;
    transition: 2s;
    right: -100%;
    bottom: -100%;
    z-index:999;
    overflow:hidden;
    visibility: hidden;
      
    iframe {
      position: absolute;
      bottom: 0;
      right: -5px;
      height: calc(100% + 80px);
      width: 100%;
      border:0;
      top: -80px;
    }
    
    @media (max-width: ${breakpoints.md}) {
      width: 100%;
      height: 100%;
      right: 0;
      
      iframe {
        right: 0;
        background: #ccc;
        transition: .3s;
      }
    }
  }
    
  &.open {
    bottom: 0;
    
    .live-chat-popup {     
      visibility: visible;
      transition: .8s;
      right:4px;
      bottom:0;
    }
    .live-chat {
      display: none;
    }
  }
  
  .above-chat {
    display: none;
  }
  
  .close-chat {
    z-index: 9999;
    position: absolute;
    right: 30px;
    top: 2px;
    padding: 5px 12px;
    border: none;
    background-color: #ffffff;
    border-radius: 25px;
    outline: none;
    transition: .3s;
    
    &:hover {
      background-color: #d8d8d8;
      cursor: pointer;
      transition: .3s;
    }
  }
  
  @media (max-width: ${breakpoints.md}) {
    display: none;
    
    &.open {
      display: block;
      
      .live-chat-popup {    
        right: 0;
        
        iframe {
          height: 100%;
          top: 0;
        }
      }
    }
    
    .above-chat {
      display: block;
      height: 60px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
    }
    
    .close-chat {
      right: 11px;
      top: 16px;
      padding: 15px;
      border-radius: 5px;
      z-index: 9999;
    }
  }  
`;

export default () => (
  <Wrap id="chat-wrapper">
    <button className="live-chat" id="live-chat" onClick={() => showHideChat('chat-wrapper', 'chat-frame')}>
      <IcomoonIcon icon="chat-2" color={color.trueBlack} size={16}/>
      <span>Live Chat</span>
    </button>
    <div className="live-chat-popup" id="live-chat-popup">
      <div className="above-chat">
        <button id="close-chat-frame-button" className="close-chat"
                onClick={() => showHideChat('chat-wrapper', 'chat-frame')}>
          <IcomoonIcon icon="close" color={color.trueBlack} size={18}/>
        </button>
      </div>
      <iframe id="chat-frame" className="chat-frame" src="about:blank" />
    </div>
  </Wrap>
);
